// write by cursor
// 生成时间: 2025-07-29 19:45:14
// 便捷的请求管理器创建函数 - 最小化业务代码改动

import { RequestManager } from './request-manager';
import { getAccessToken, getRefreshToken, setAccessToken, setRefreshToken } from './session-token';

/**
 * 简化的配置接口 - write by cursor
 */
export interface SimpleRequestConfig {
  defaultDomain: string;
  errorCodeMap?: Record<number, string>;
  onAuthError?: () => void;
  disableGlobalErrorHandle?: boolean; // 全局禁用错误处理，接口需要主动开启
  useOriginalError?: boolean; // 是否使用原始错误
}

/**
 * 创建请求管理器实例 - write by cursor
 * 使用内置的Token管理，最小化配置
 */
export function createRequestManager(config: SimpleRequestConfig) {
  const requestManager = new RequestManager({
    ...config,
    tokenConfig: {
      getAccessToken,
      getRefreshToken,
      setAccessToken,
      setRefreshToken,
      onAuthError: config.onAuthError,
    },
  });

  return {
    // 请求方法
    get: requestManager.get.bind(requestManager),
    post: requestManager.post.bind(requestManager),
    put: requestManager.put.bind(requestManager),
    delete: requestManager.delete.bind(requestManager),
    patch: requestManager.patch.bind(requestManager),
    request: requestManager.request.bind(requestManager),
    
    // 工具方法
    errorHandler: requestManager.getErrorHandler(),
    endpointManager: requestManager.getEndpointManager(),
    destroy: requestManager.destroy.bind(requestManager)
  };
} 